import { requestApi } from "./api";

export interface RecommendationListItem {
  recommendationCode: string;
  requestedAt: string;
  ingredients: string;
  recipeCount: number;
  status: "REQUESTED" | "PROCESSING" | "COMPLETED" | "FAILED";
}

export interface RecommendationRecipe {
  id: number;
  name: string;
  description: string;
  kcal: number;
  carbs: number;
  protein: number;
  fat: number;
  cookingMinutes: number;
  difficulty: "쉬움" | "보통" | "어려움";
  servings: number;
  ingredients: string[];
  steps: string[];
}

export interface RecommendationResult {
  recommendationCode: string;
  requestedAt: string;
  completedAt: string;
  ingredients: string;
  excludedIngredients: string;
  request: string;
  diningPartySize: "ONE" | "TWO" | "THREE_TO_FOUR" | "FIVE_PLUS";
  recommendationPoint: string;
  tags: string[];
  tip: string;
  recipes: RecommendationRecipe[];
}

export interface FridgeImageAnalysis {
  ingredients: string[];
  note: string;
  model: string;
  promptVersion: string;
}

function memberToken() {
  try {
    const session = JSON.parse(sessionStorage.getItem("betterTableMemberSession") ?? "{}");
    if (typeof session.token === "string" && session.token) return session.token as string;
  } catch {
    // The API reports an unauthorized session below.
  }
  throw new Error("로그인 후 AI 식단 추천을 이용해 주세요.");
}

function memberHeaders() {
  return { Authorization: `Bearer ${memberToken()}` };
}

export function createRecommendation(payload: {
  ingredients: string;
  excludedIngredients: string;
  request: string;
  diningPartySize?: "ONE" | "TWO" | "THREE_TO_FOUR" | "FIVE_PLUS";
}) {
  return requestApi<RecommendationResult>("/recommendations", {
    method: "POST",
    headers: memberHeaders(),
    body: JSON.stringify(payload),
  });
}

export function analyzeFridgeImages(files: File[]) {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));
  return requestApi<FridgeImageAnalysis>("/recommendations/analyze-images", {
    method: "POST",
    headers: memberHeaders(),
    body: formData,
  });
}

export function getRecommendation(code: string) {
  return requestApi<RecommendationResult>(`/recommendations/${encodeURIComponent(code)}`, {
    headers: memberHeaders(),
  });
}

export function listRecommendations(limit = 20) {
  return requestApi<RecommendationListItem[]>(`/recommendations?limit=${limit}`, {
    headers: memberHeaders(),
  });
}
